module.exports = __webpack_public_path__ + "static/img/banner.f5093bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner.png
// module id = 7E6U
// module chunks = 1